/**
 *
 *
 * @export 针对后台返回状态码进行mes过滤
 * @param {*} code 后台返回状态码
 * @returns
 */
export function searchCarCode (code) {
  let mes = ''
  switch (code) {
    case 70003:
      mes = '您的剩余票数不足，请前往会员商城充值!'
      break;
    default:
      mes = '请核对车牌号或该车暂无数据'
      break;
  }
  return mes
}